module.exports = __webpack_public_path__ + "img/coupon-bag.09328dd9.png";